import { Body1, Body2, Caption, useDeviceType } from '@cian/ui-kit';
import type { TColors } from '@cian/ui-kit-design-tokens/colors';
import cn from 'clsx';
import React from 'react';
import { ETestIds } from 'shared/constants/testIds';
import styles from './styles.css';

export interface IBreadcrumbNavItem {
  url: string;
  anchor: string;
  color?: TColors;
}

interface IBreadcrumbsProps {
  items: IBreadcrumbNavItem[];
}

export const Breadcrumbs: React.FC<IBreadcrumbsProps> = ({ items }) => {
  const deviceType = useDeviceType();

  if (items.length === 0) {
    return null;
  }

  const Text = deviceType === 'phone' ? Caption : Body2;

  const lastIndex = items.length - 1;

  return (
    <nav
      className={cn(styles['breadcrumbs'], styles[deviceType])}
      aria-label="Хлебные крошки"
      data-testid={ETestIds.Breadcrumbs}
    >
      {items.map((item, index) => {
        const isLast = index === lastIndex;
        const textColor = item.color ?? 'text-primary-default';
        const breadcrumb = (
          <Text as="span" color={textColor} display="inline-block">
            {item.anchor}
          </Text>
        );

        return (
          <React.Fragment key={`${index}-${item.url}`}>
            {index !== 0 && (
              <span className={styles['breadcrumb-separator']} aria-hidden>
                <Body1 color="text-secondary-disabled">/</Body1>
              </span>
            )}
            {isLast ? (
              breadcrumb
            ) : (
              <a className={styles['breadcrumb-link']} href={item.url}>
                {breadcrumb}
              </a>
            )}
          </React.Fragment>
        );
      })}
    </nav>
  );
};
